@if (!isError) {
	<button mat-icon-button class="dictation-button" (click)="openDictationDialog()">
		<mat-icon>microphone</mat-icon>
	</button>
}

@switch (state) {
	@case (RecordingStates.Waiting) {
		<button class="big-blue-button" mat-ripple (click)="startMic()">
			Start scribe
		</button>

		@if (uploadEnabled) {
			<input #fileInput hidden="hidden" type="file" onclick="this.value=null" (change)="fileInputChange($event)"
			       [accept]="mimesAccepted"/>

			<button class="big-white-button" mat-ripple (click)="fileInput.click()">
				<mat-icon>upload</mat-icon>
				Upload file
			</button>
		}
	}
	@case (RecordingStates.Recording) {
		<button class="big-pink-button" mat-ripple (preventDoubleClick)="stopMic()">
			<mat-icon>pause</mat-icon>
			<span>Pause scribe</span>
			<span class="duration">{{ recordingTime | date : 'mm:ss' }}</span>
		</button>

		<button class="big-pink-text-button" mat-ripple (preventDoubleClick)="selectTemplate()">
			End & select template
		</button>
	}
	@case (RecordingStates.Done) {
		<button class="big-blue-button" mat-ripple (click)="startMic()">
			<mat-icon>resume</mat-icon>
			<span>Resume scribe</span>
			<span class="duration">{{ recordingTime | date : 'mm:ss' }}</span>
		</button>

		<button class="big-white-button" mat-ripple (click)="selectTemplate()">
			End & select template
		</button>
	}
	@case (RecordingStates.Unsupported) {
		<div class="error">Microphone access is currently unavailable. Please ensure it's enabled in your device settings.</div>
	}
	@case (RecordingStates.NoDevices) {
		<div class="error">Microphone access is currently unavailable. Please ensure it's enabled in your device settings.</div>
	}
	@case (RecordingStates.MicDeclined) {
		<div class="error">It looks like you declined mic access, please refresh the page and try again.</div>
	}
	@case (RecordingStates.Error) {
		<div class="error">It looks like there was an error, check log for details.</div>
	}
}
